import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b1e1f47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-file" }
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-files" }, null, -1))
const _hoisted_4 = { class: "message-file-content" }
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "box",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
      title: _ctx.$t('TUIChat.单击下载')
    }, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", null, _toDisplayString(_ctx.data.name), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.data.size), 1)
      ])
    ], 8, _hoisted_2),
    (_ctx.data.progress)
      ? (_openBlock(), _createElementBlock("progress", {
          key: 0,
          value: _ctx.data.progress,
          max: "1"
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}